import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../../redux/type";
import {
  RazorBadgeTwo,
  RazorCopyText,
  RazorDateTime,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
  RazorTwinValue,
} from "../../../../../components/razor-reuse";
import ExchangeCurrencyText from "../../../../../components/fragment/cur-text/ExchangeCurrencyText";
import DotActionDropFragment from "../../../../../components/fragment/actionIconFragment/DotActionDropFragment";
import PaginationFragment from "../../../../../components/fragment/pagination/PaginationFragment";
import {
  getCustomerSingleTransaction,
  getCustomerWallet,
} from "../../../../../redux/customer";
import FilterReusableComp from "../../../../../components/FilterReusableComp";
import NoContentPage from "../../../../../layout/dashboard/no-content/NoContentPage";
import CurrencyText from "../../../../../components/fragment/cur-text/CurrencyText";
import TitleTextFragment from "../../../../../components/fragment/title-text/TitleTextFragment";
import Skeleton from "react-loading-skeleton";

const Transactions = ({
  setShowModal,
  setSingleChild,
}: {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSingleChild: React.Dispatch<React.SetStateAction<{}>>;
}) => {
  const dispatch = useDispatch();
  // Query
  const [page, setCurrentPage] = useState(1); /// Pagination
  const [filterOneVal, setFilterOneVal] = useState<any>(""); // status
  const [filterTwoVal, setFilterTwoVal] = useState<any>(""); // currency
  const [search, setSearch] = useState(""); // currency

  const { loading_transaction, customer_transaction, customer_wallet } =
    useSelector((state: RootState) => state.customer);

  // Get customer transaction endpoint call
  const cust_id = localStorage?.getItem("cors_key") || "";
  useEffect(() => {
    let obj = {
      customer_id: cust_id,
      transaction_type: "swap_deal",
      page,
      search,
      "filter[status]": filterOneVal?.value,
    };
    dispatch(getCustomerSingleTransaction(obj) as any);
  }, [page, search, filterOneVal, cust_id, dispatch]);

  useEffect(() => {
    dispatch(getCustomerWallet(cust_id) as any);
  }, [cust_id, dispatch]);

  const headerList = [
    "Recipient’s Name",
    "Amount",
    "Trx Reference",
    "Currency EXR Type  ",
    "Date",
    "Status",
    "Action",
  ];

  const selectListOne = [
    { label: "Successful", value: "successful" },
    { label: "Failed", value: "failed" },
    { label: "Pending", value: "pending" },
    { label: "Processing", value: "processing" },
    { label: "Reversed", value: "reversed" },
    { label: "All status", value: "" },
  ];

  const actionList = [
    {
      label: "View Transaction",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal(true);
      },
      textColor: "",
    },
    {
      label: "Generate Receipt",
      onClick: (_param?: any) => {},
      textColor: "",
    },
  ];

  const removeSelectedList = (list: any) => {
    if (list?.length > 0) {
      const newlist = list?.filter(
        (chi: any) => chi?.label !== filterOneVal?.label,
      );
      const secondlist = newlist?.filter(
        (chi: any) => chi?.label !== filterTwoVal?.label,
      );
      return secondlist;
    }
  };

  return (
    <>
      <div className="transaction-index-wrap-box-smartsend">
        {/* filter section start */}
        <FilterReusableComp
          defaultSelectOne="Status"
          selectOneList={removeSelectedList(selectListOne)}
          selectOneValue={filterOneVal}
          onSelectOne={(param) => {
            setFilterOneVal(param);
            setCurrentPage(1);
          }}
          onSearch={(param: any) => {
            if (String(param)?.length > 2) {
              setSearch(param);
              setCurrentPage(1);
            }
            if (String(param)?.length < 1) {
              setSearch("");
              setCurrentPage(1);
            }
          }}
          hideExport
          searchPlaceholder="Search for transaction"
        />
        {customer_transaction?.transactions?.meta?.total < 1 ? (
          <NoContentPage
            title="No Transaction History"
            text="User has not carried out any transactions yet. Once they do, it will show up here."
          />
        ) : (
          <>
            <div className="card-list-box !grid-cols-3 !gap-[2rem]">
              {customer_wallet?.data?.map((chi: any, idx: any) => {
                return (
                  <div
                    key={idx}
                    className={`card-box ${
                      chi?.status === "inactive"
                        ? `card-box-inactive !bg-[#ffc0430f]`
                        : ""
                    }`}
                  >
                    <div className="title-box">
                      <CurrencyText
                        currency={chi?.currency_code || "ngn"}
                        imgSize="2rem"
                      />
                      <p className="text">{chi?.currency_code || "---"}</p>
                    </div>
                    {chi?.status === "inactive" ? (
                      <div className="inactive-box">
                        {!loading_transaction ? (
                          <RazorBadgeTwo className="pending" text="Pending" />
                        ) : (
                          <Skeleton
                            width={55}
                            height={20}
                            style={{ borderRadius: "1.2rem" }}
                          />
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="count-volume-box">
                          {loading_transaction ? (
                            <>
                              <div className="">
                                <Skeleton
                                  style={{ marginBottom: "2rem" }}
                                  width={50}
                                  height={12}
                                />
                                <Skeleton width={70} height={15} />
                              </div>
                            </>
                          ) : (
                            <TitleTextFragment
                              className="text-title-box"
                              titleColor="#596080"
                              titleSize="1.25rem"
                              textSize="2rem"
                              textColor="#191C1F"
                              title="Available Balance"
                              text={RazorNumberFormat(chi?.available_balance, {
                                symbol: chi?.currency_code,
                              })}
                            />
                          )}
                          {loading_transaction ? (
                            <>
                              <div className="">
                                <Skeleton
                                  style={{ marginBottom: "2rem" }}
                                  width={50}
                                  height={12}
                                />
                                <Skeleton width={70} height={15} />
                              </div>
                            </>
                          ) : (
                            <div className="tooltip-hover-wrap">
                              <TitleTextFragment
                                className="text-title-box"
                                titleColor="#596080"
                                titleSize="1.25rem"
                                textSize="2rem"
                                textColor="#191C1F"
                                title="Ledger Balance"
                                text={RazorNumberFormat(chi?.ledger_balance, {
                                  symbol: chi?.currency_code,
                                })}
                              />
                            </div>
                          )}
                          {/* label value text end */}
                        </div>
                      </>
                    )}

                    {/* count volume box end */}
                  </div>
                );
              })}
            </div>
            {/* filter section end */}
            <div className="table-section-box">
              <RazorTable headerList={headerList}>
                {customer_transaction?.transactions?.data?.map(
                  (chi: any, idx: any) => {
                    return (
                      <RazorTableRow
                        key={idx}
                        loading={loading_transaction}
                        one={
                          <RazorTwinValue
                            one={RazorTextTrim(
                              chi?.beneficiary_details?.details?.account_name?.trim() ||
                                chi?.beneficiary_details?.account_name?.trim() ||
                                chi?.recipient_name?.trim() ||
                                "----",
                              35,
                            )}
                            two={`${
                              RazorTextTrim(
                                chi?.beneficiary_details?.email ||
                                  chi?.beneficiary_details?.details?.email ||
                                  chi?.beneficiary_details?.details
                                    ?.interac_email ||
                                  chi?.beneficiary_details?.interac_email,
                                30,
                              ) || ""
                            }`}
                          />
                        }
                        two={RazorNumberFormat(chi?.total_amount, {
                          hideSymbol: false,
                          symbol: chi?.source_currency?.code,
                        })}
                        three={
                          <RazorCopyText
                            reference={chi?.trx_reference}
                            textToCopy={chi?.trx_reference}
                            outerCopy
                          />
                        }
                        four={
                          <ExchangeCurrencyText
                            curOne={chi?.source_currency?.code || "NIL"}
                            curTwo={chi?.destination_currency?.code || "NIL"}
                            urlOne={
                              chi?.source_currency?.code === "USD"
                                ? ""
                                : chi?.source_currency?.code === "EUR"
                                  ? ""
                                  : chi?.source_currency?.code === "GBP"
                                    ? ""
                                    : chi?.source_currency?.code === "NGN"
                                      ? ""
                                      : chi?.source_currency?.code === "CAD"
                                        ? ""
                                        : chi?.source_currency?.logo
                            }
                            urlTwo={
                              chi?.destination_currency?.code === "USD"
                                ? ""
                                : chi?.destination_currency?.code === "EUR"
                                  ? ""
                                  : chi?.destination_currency?.code === "GBP"
                                    ? ""
                                    : chi?.destination_currency?.code === "NGN"
                                      ? ""
                                      : chi?.destination_currency?.code ===
                                          "CAD"
                                        ? ""
                                        : chi?.destination_currency?.logo
                            }
                          />
                        }
                        five={<RazorDateTime date={chi?.created_at} />}
                        six={
                          <RazorBadgeTwo
                            className={
                              chi?.status === "failed"
                                ? "failed"
                                : chi?.status === "successful"
                                  ? "success"
                                  : chi?.status === "completed"
                                    ? "success"
                                    : chi?.status === "pending"
                                      ? "pending"
                                      : chi?.status === "processing"
                                        ? "pending"
                                        : chi?.status === "submitted"
                                          ? "pending"
                                          : ""
                            }
                            text={chi?.status}
                          />
                        }
                        seven={
                          <DotActionDropFragment
                            list={actionList}
                            detail={chi}
                          />
                        }
                      />
                    );
                  },
                )}
              </RazorTable>
            </div>
            {/* table end */}
            {/* pagination start */}
            <PaginationFragment
              currentPage={
                customer_transaction?.transactions?.meta?.current_page || 1
              }
              perPage={customer_transaction?.transactions?.meta?.per_page}
              totalPage={customer_transaction?.transactions?.meta?.total}
              onPageChange={(num) => {
                setCurrentPage(num);
              }}
              hidePagination={loading_transaction}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Transactions;
